import { Cidade } from './Cidade.js';

export class Endereco {
  constructor() {
    this.id = 0;
    this.cidadeId = null;
    this.cep = '';
    this.logradouro = '';
    this.numero = '';
    this.bairro = '';
    this.complemento = '';
    this.cidade = new Cidade();
  }

  normalizar() {
    this.cep = (this.cep || '').trim();
    this.logradouro = (this.logradouro || '').trim();
    this.numero = (this.numero || '').trim();
    this.bairro = (this.bairro || '').trim();
    this.complemento = (this.complemento || '').trim();
  }

  Normalizar() {
    this.normalizar();
  }
}
